import { AppHelper } from "../../appHelper";
import React from "react";

export default class SlotDebugInfo extends React.Component<any, any> {
    common = new AppHelper();

    constructor(props: any) {
        super(props)
        this.common.init(this);
    }

    componentDidUpdate() {
        const element = document.getElementById("SlotDebugInfo");
        element?.firstElementChild?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    render() {
        const resources: SlotDebugResource[] = this.props.data;

        if (resources == null)
            return null;

        return (
            <div style={{ padding: "5px", display: "block", overflowY: "scroll", height: "inherit" }} id={"SlotDebugInfo"}>
                {resources.map((resource, index) => {
                    return (
                        <div key={resource.ressNr} id={"SlotDebugInfo_" + resource.ressNr}>
                            <div style={{ marginTop: "10px" }}>
                                <span style={{ fontWeight: "bold", marginTop: "5px" }}>{resource.ressNr} {resource.ressName}</span>
                                <br />
                            </div>
                            {resource.dates.map((dates, index) => {
                                const d = dates.date == null ? "" : kendo.toString(kendo.parseDate(dates.date.toString()), 'd');
                                return (
                                    <div key={resource.ressNr + d} id={"SlotDebugInfo_" + resource.ressNr + "_" + d}>
                                        <span style={{ fontWeight: "bold", float: "right", fontSize: "x-small", margin: "5px" }}>{d}</span>
                                        <br />
                                        {dates.notApplicable.map((reason, index) => {
                                            return (
                                                <div key={resource.ressNr + d + kendo.guid().toString()}>
                                                    <span style={{ fontSize: "x-small" }}>{reason}</span>
                                                    <br />
                                                </div>)
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })};
            </div>
        );
    }
};

export interface SlotDebugResource {
    ressNr: string,
    ressName: string,
    dates: Array<SlotDebugDates>
}

export interface SlotDebugDates {
    date: Date,
    notApplicable: Array<string>
}